import { useEffect } from "react";
import { Link } from "react-router-dom";
import PageMeta from "../components/seo/PageMeta";
import "../styles/pages.css";

export default function NotFoundPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <section className="page page--narrow" aria-label="Page not found">
      <PageMeta
        title="Page Not Found"
        description="This page is not available on cj.photos."
        path="/404"
        noindex
      />
      <p className="page__eyebrow">404</p>
      <h1 className="page__title">This page isn&rsquo;t here.</h1>
      <p className="page__lede">
        The link might be old, or the address might have a typo — either way,
        there&rsquo;s nothing at this URL.
      </p>
      <Link to="/" className="btn btn--primary">
        Back to home
      </Link>
    </section>
  );
}
